var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.5H4.6C4.03995 11.5 3.75992 11.5 3.54601 11.609C3.35785 11.7049 3.20487 11.8578 3.10899 12.046C3 12.2599 3 12.5399 3 13.1V21.5M16.5 11.5H19.4C19.9601 11.5 20.2401 11.5 20.454 11.609C20.6422 11.7049 20.7951 11.8578 20.891 12.046C21 12.2599 21 12.5399 21 13.1V21.5M16.5 21.5V6.7C16.5 5.5799 16.5 5.01984 16.282 4.59202C16.0903 4.21569 15.7843 3.90973 15.408 3.71799C14.9802 3.5 14.4201 3.5 13.3 3.5H10.7C9.57989 3.5 9.01984 3.5 8.59202 3.71799C8.21569 3.90973 7.90973 4.21569 7.71799 4.59202C7.5 5.01984 7.5 5.5799 7.5 6.7V21.5M22 21.5H2M11 7.5H13M11 11.5H13M11 15.5H13",
    stroke: "#A459FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding07);
export default __webpack_public_path__ + "static/media/building-07.301625c3257cdd22f636125d7e8ef09c.svg";
export { ForwardRef as ReactComponent };